var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPalletEconomy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 22H17.5a.5.5 0 010-1h3.25c.689 0 1.25-.561 1.25-1.25s-.561-1.25-1.25-1.25h-1.5c-1.241 0-2.25-1.01-2.25-2.25S18.009 14 19.25 14h3.25a.5.5 0 010 1h-3.25c-.689 0-1.25.561-1.25 1.25s.561 1.25 1.25 1.25h1.5c1.241 0 2.25 1.01 2.25 2.25S21.991 22 20.75 22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.012 24a.5.5 0 01-.5-.5v-1.793a.5.5 0 011 0V23.5a.5.5 0 01-.5.5zM20.012 15a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5zM19.5 11a.5.5 0 01-.5-.5V6.059l-8.77 4.388a.5.5 0 01-.447-.894l9.494-4.75A.5.5 0 0120 5.25v5.25a.5.5 0 01-.5.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.994 20c-.08 0-.16-.02-.233-.058l-9.494-5A.5.5 0 010 14.5V5.25a.5.5 0 01.724-.447l9.494 4.75a.5.5 0 01.276.447v9.5a.5.5 0 01-.5.5zM1 14.198l8.494 4.474v-8.363L1 6.059z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 5.75a.497.497 0 01-.223-.053L9.994 1.059.724 5.697a.501.501 0 01-.448-.894L9.77.053a.502.502 0 01.447 0l9.506 4.75a.5.5 0 01-.223.947z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.043 11.739a.5.5 0 01-.5-.5V7.521a.5.5 0 01.276-.447l9.494-4.75a.501.501 0 01.447.895L5.543 7.831v3.409a.499.499 0 01-.5.499zM9.994 20a.5.5 0 01-.218-.95l5.506-2.659a.5.5 0 01.434.9L10.21 19.95a.488.488 0 01-.216.05z"
  })));
}

export default SvgPalletEconomy;